import React from "react";

import Button from 'react-bootstrap/Button'

import { AuthConsumer } from "./AuthContext";
import { PREVIOUSLY_IN_INK } from '../../utils/auth-jwt';

const Logout = () => (
  <AuthConsumer>
    {({ logout, user }) => (
      <div className='d-flex justify-content-center text-nowrap'>
        <Button
          onClick={() => {
            localStorage.removeItem(PREVIOUSLY_IN_INK);
            logout();
          }}
          variant="secondary"
          size="sm">Log out
        </Button>
      </div>
    )}
  </AuthConsumer>
);

export default Logout;
